import { createContext } from 'react';
import ManagementContextPropsType from './ManagementContextPropTypes';
import config from './config';

export default createContext<ManagementContextPropsType>(config);
